import Teacher from '../../api/teacher';

const state = {
  schools: [],
  school: {
    id:'',
    campusName:'选择学校'
  },
  grade: {
    id:'',
    gradeName:'选择班级'
  },
  grades:[],
  listStudents:[],//回显学生数据,
  index:'',//学生id
  selectedCourse:'',//存储下拉框选中的什么分类
  studentList:{}//签到列表数据
};

const getters = {
  schools (state) {
    return state.schools;
  },
  school (state) {
    return state.school;
  },
  grade (state) {
    return state.grade;
  },
  grades (state) {
    return state.grades;
  },
  studentList(state){
    return state.listStudents;
  },
  selectedCourse(state){
    return state.selectedCourse
  }
};
const actions = {
  getAllSchools({commit, state}) {
    // 获取校区和班级数据
    Teacher.getAllSchools().then(response => {
      // if (response.errno === '0') {
        commit('setSchools', {schools: response.rows});
        if (response.rows.length > 0) {
          commit('setSchool', response.rows[0]);
          //加载页面时就进行查询按学校id查询班级内容 调接口
          Teacher.getAllClass(response.rows[0].id).then(response =>{
            commit('setGrades',response.rows);
            commit('setGrade',response.rows[0]);
          }).catch(e => {
            console.log(e);
          });
        }
      // } else {
      //   console.log('未获取到数据');
      // }
    }).catch(e => {
      console.log(e);
    });
  },
  getAllSigninStudentList({commit},list){
    Teacher.getAllSignInStudents(list).then(response => {
      // this.courseData = response.rows;
      // if(response.rows.length > 0){
        commit("getAllSignInStudentsList",response.rows)
      // }
      // // 将第一项数据的值赋给 selectedCourse 属性
      // if (this.courseData.length > 0) {
      //   this.selectedCourse = this.selectedCourseStore!='' ? this.selectedCourseStore : this.courseData[0].course_title;
      // }
      
      // Indicator.close();
    }).catch(e => {
      // Indicator.close();
    });
  }
};
const mutations = {
  clear(state) {
    state.schools = [];
    state.grades = [];
    state.school = '选择学校';
    state.grade='选择班级';
  },
  setSchools(state, payload) {
    state.schools = payload.schools;
  },
  setSchool(state, school) {
    state.school = school;
  },
  setGrades(state, grades) {
    state.grades = grades;
  },
  setGrade(state, grade) {
    state.grade = grade;
  },
  studentList(state,list){
    state.listStudents = list;
  },
  studentId(state,index){
    state.index=index;
  },
  selectedCourse(state,value){
    state.selectedCourse=value;
  },
  getAllSignInStudentsList(state,value){
    state.studentList = value;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/teacherschools.js